import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import { KEYS } from 'helpers/react-query.config';

function useGetWorkFlowOrderDetail(id: number) {
  const { showApiError } = useGlobalContext();
  const { client: clientApi } = useApiContext();
  const { t } = useTranslation('global');

  const getWorkFlowOrderDetail = useQuery(
    KEYS.client.workFlowOrder.findByID(String(id)),
    () => clientApi.workFlowOrder.findByID(String(id)),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      enabled: !!id,
      onError: (error) => showApiError(error, t('errorMessages.ticketDetails'))
    }
  );

  return getWorkFlowOrderDetail;
}

export default useGetWorkFlowOrderDetail;
